import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/node_modules/@interness/web-core/src/templates/mdx/default.js";
import { graphql } from 'gatsby';
import { RiTeamFill } from 'react-icons/ri';
import TeamMembers from '@interness/web-core/src/components/modules/TeamMembers';
import CallToAction from '@interness/theme-sonora/src/components/CallToAction/CallToAction';
export const query = graphql`
  query {
    headerImages: directusMediaCollection(name: {eq: "team-header"}) {
      name
      images: media {
        file {
          localFile {
            name
            childImageSharp {
              fluid(maxWidth: 1400, cropFocus: CENTER) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const HeaderImage = makeShortcode("HeaderImage");
const Img = makeShortcode("Img");
const Heading = makeShortcode("Heading");
const Wrapper = makeShortcode("Wrapper");
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<HeaderImage mdxType="HeaderImage">
    <Img fluid={props.data.headerImages.images[0].file.localFile.childImageSharp.fluid} alt='Team' mdxType="Img" />
</HeaderImage>
<hr></hr>
<Heading subtitle={'Juwelier Spieker'} icon={<RiTeamFill mdxType="RiTeamFill" />} mdxType="Heading">Über uns</Heading>
<Wrapper mdxType="Wrapper">
<h2 {...{
        "id": "team"
      }}>{`Team`}</h2>
<p>{`Unser fachlich versiertes Team berät Sie gern!`}</p>
<TeamMembers layout={'grid'} mdxType="TeamMembers" />
<h2 {...{
        "id": "philosophie"
      }}>{`Philosophie`}</h2>
<h3 {...{
        "id": "design-trifft-qualitat"
      }}>{`Design trifft Qualität`}</h3>
<p>{`Bereits seit 1954 dürfen wir unseren Kunden ein ganz besonderes Einkaufserlebnis bieten. In unserem Juwelierbereich wie auch in der Goldschmiedegalerie schaffen wir ein inspirierendes Ambiente, unser kompetentes Team und unsere sorgfältig zusammengestellte Auswahl hochwertiger Schmuckstücke, Uhren und Design-Kollektionen bilden den Rahmen dafür.`}</p>
<p>{`In ausführlichen Gesprächen erhalten Sie genau die Beratung, die Sie zu dem Schmuckstück führt, das Ihre Augen funkeln lässt. Unsere hauseigene Kollektion wird von unseren Goldschmieden entworfen und in präziser Handarbeit gefertigt. In ihr zeigt sich unsere kompromisslose Begeisterung für die Verbindung von edlen Materialien, innovativem Design und meisterlicher Handwerkskunst.`}</p>
<p>{`Gern nehmen wir uns auch Ihrer eigenen Kostbarkeiten an, arbeiten diese auf, setzen Sie wieder in Stand oder erwecken sie durch unsere Umarbeitungsideen in unsererm Meisteratelier zu neuem Leben.`}</p>
</Wrapper>
<hr></hr>
<CallToAction mdxType="CallToAction" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      